import { PaginationProps, SortDirection } from '@touche-lts/panel-ui/dist/utilities'
import {
  CustomersTableSearchProps,
  CustomersTableSortProps,
} from './customers-table-store.types'

export const initialDepartmentsTablePaginationProps: PaginationProps<CustomersTableSortProps> = {
  page: 0,
  size: window.innerWidth >= 1920 ? 10 : 6,
  sortDirection: SortDirection.ASC,
  sortProp: CustomersTableSortProps.FIRST_NAME,
  totalElements: 0,
  totalPages: 0
}

export const initialCustomersTableSearchProps: CustomersTableSearchProps = {}

export const customersTableNeedTimeoutSearchProps: Array<keyof CustomersTableSearchProps> = []



